/** Keep sidebar width and main content offset in sync (4rem / 16rem). */
export function sidebarLayoutClasses(isCollapsed: boolean) {
  return isCollapsed
    ? { sidebar: 'w-16', spacer: 'w-16' }
    : { sidebar: 'w-64', spacer: 'w-64' };
}

export function readSidebarCollapsedFromStorage(): boolean {
  if (globalThis.localStorage === undefined) return false;
  return globalThis.localStorage.getItem('ffshop-sidebar-collapsed') === 'true';
}
